import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Table, Icon, Input, Button, Select } from 'antd'
import InsuranceCaseCoversPopup from '@components/Popup/InsuranceCaseCoversPopup'
import InsuranceSubPoliciesPopup from '@components/Popup/InsuranceSubPoliciesPopup'
import { policyType } from '@texts/policy'
import { caseSource } from '@texts/insuranceCases'

import * as style from './style.scss'

@inject((store: any) => {
    const { popupStore, companiesStore } = store
    return { popupStore, companiesStore }
})
@observer
class InsuranceCases extends Component<any> {
    state = {
        currentList: [],
        filters: {},
        filteredList: []
    }

    async componentDidMount() {
        await this.props.companiesStore.getCompanies()

        // Initialize the lists from the first list that arrives.
        const list = this.props.list || []
        this.setState({ currentList: [...list], filteredList: [...list] })
    }
    componentDidUpdate(prevProps) {
        // Re-sync when the incoming list reference changes (cheaper than a deep
        // JSON.stringify comparison) and re-apply the current filters.
        if (prevProps.list !== this.props.list) {
            this.setState({ currentList: [...(this.props.list || [])] })
            this.handleFilteredList()
        }
    }

    setCasesFilter = values => {
        const newFilters = { ...this.state.filters }
        Object.keys(values).forEach(key => {
            if (key in newFilters && !values[key]) {
                delete newFilters[key]
            } else {
                newFilters[key] = values[key]
            }
        })
        this.setState({ filters: newFilters }, () => this.handleFilteredList())
    }

    handleFilteredList = () => {
        const { filters } = this.state
        const list = this.props.list || []
        const filterKeys = Object.keys(filters)
        let filteredList = []
        if (filterKeys.length > 0) {
            // policy_name / generic_policy_name are driven by the same search box,
            // so they form an OR pair; that pair is AND-ed with every other filter
            // (e.g. company_id).
            const nameKeys = ['policy_name', 'generic_policy_name'].filter(key => key in filters)
            const otherKeys = filterKeys.filter(key => !nameKeys.includes(key))
            // Plain substring match (indexOf) — String.search treats its argument as a
            // RegExp, so raw user input like "(" / "[" / "*" would throw.
            const matches = (listItem, key) =>
                listItem[key] != null && listItem[key].toString().indexOf(filters[key].toString()) > -1
            filteredList = list.filter(listItem => {
                const nameMatch = nameKeys.length === 0 || nameKeys.some(key => matches(listItem, key))
                const otherMatch = otherKeys.every(key => matches(listItem, key))
                return nameMatch && otherMatch
            })
        } else {
            filteredList = [...list]
        }
        this.setState({ filteredList })
    }

    handleResetFilters = () => {
        const filteredList = [...(this.props.list || [])]
        this.setState({ filters: {}, filteredList })
    }

    render() {
        const { loading, companiesStore, user_id } = this.props
        const { filteredList, filters } = this.state
        const showList = filteredList.filter(item => item.user_id === user_id)
        const columns = [
            {
                title: 'מקור',
                key: 'source',
                align: 'right',
                render: (_, record) => <div>{caseSource[record.source]}</div>
            },
            {
                title: 'חברת ביטוח',
                key: 'company',
                width: 200,
                align: 'right',
                render: (_, record) => (
                    <div>
                        {record.company_name ? (
                            <a
                                href={`/insurance/${record.company_id}`}
                                style={{ textDecoration: 'underline', color: 'initial' }}
                                target="_blank"
                            >
                                {record.company_name} ({record.company_id})
                            </a>
                        ) : (
                            <div>
                                <div style={{ color: 'red' }}>
                                    <strong>
                                        <Icon type="close" /> {record.company_long_name} (אין התאמה)
                                    </strong>
                                </div>
                            </div>
                        )}
                    </div>
                )
            },
            {
                title: 'שם פוליסה',
                key: 'policy_id',
                width: 400,
                align: 'right',
                render: (_, record) => (
                    <div>
                        {record.policy_id ? (
                            <a
                                style={{ textDecoration: 'underline', color: 'initial', marginRight: '0.2rem' }}
                                href={`/insurance/${record.company_id}/${record.policy_id}`}
                                target="_blank"
                            >
                                {record.policy_id} - {record.generic_policy_name ? record.generic_policy_name : ''}
                            </a>
                        ) : (
                            <span style={{ color: 'red' }}>
                                <strong>
                                    <Icon type="close" /> {record.policy_name ? record.policy_name : 'אין התאמה'}
                                </strong>
                            </span>
                        )}
                        <div>
                            <strong>
                                <small>תוקף פוליסה: {record.insurance_period}</small>
                            </strong>
                        </div>
                        <div>
                            {record.insuranceCaseRightParameters.length > 0 ? (
                                <a
                                    style={{ textDecoration: 'underline' }}
                                    onClick={() =>
                                        this.props.popupStore.togglePopup('insuranceCaseCovers', {
                                            policy_name: record.generic_policy_name || record.policy_name,
                                            covers: record.insuranceCaseRightParameters
                                        })
                                    }
                                >
                                    הצג כיסויים
                                </a>
                            ) : (
                                <span>אין כיסויים ייחודיים</span>
                            )}

                            {record.subPolicies ? (
                                <>
                                    <span style={{ margin: '0 0.5rem' }}>|</span>
                                    {record.subPolicies.length > 0 ? (
                                        <a
                                            style={{ textDecoration: 'underline' }}
                                            onClick={() =>
                                                this.props.popupStore.togglePopup('insuranceSubPolicies', {
                                                    policy_name: `${record.generic_policy_name ||
                                                        record.policy_name} (${record.policy_id})`,
                                                    policy_number: record.policy_number,
                                                    policies: record.subPolicies
                                                })
                                            }
                                        >
                                            פוליסות משנה ({record.subPolicies.length})
                                        </a>
                                    ) : (
                                        'ללא פוליסות משנה'
                                    )}
                                </>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                )
            },
            {
                title: 'סוג הפוליסה',
                key: 'policy_type',
                align: 'right',
                render: (_, record) => (
                    <div>
                        {policyType[record.policy_type] ? (
                            <div>{policyType[record.policy_type]}</div>
                        ) : (
                            <div>
                                <div style={{ color: 'red' }}>
                                    <strong>
                                        <Icon type="close" /> {record.policy_type} (כשל)
                                    </strong>
                                </div>
                            </div>
                        )}
                    </div>
                )
            },
            {
                title: 'קטגוריה ראשית',
                key: 'main_category',
                align: 'right',
                width: 270,
                render: (_, record) => (
                    <div>
                        {record.main_name ? (
                            <div>
                                {record.main_name} ({record.main_category})
                            </div>
                        ) : (
                            <div>
                                <div style={{ color: 'red' }}>
                                    <Icon type="close" /> {record.main_category}
                                </div>
                            </div>
                        )}
                    </div>
                )
            },
            {
                title: 'קטגוריה משנית',
                key: 'sub_category',
                width: 270,
                align: 'right',
                render: (_, record) => (
                    <div>
                        {record.sub_name ? (
                            <div>
                                {record.sub_name} ({record.sub_category})
                            </div>
                        ) : (
                            <div>
                                <div style={{ color: 'red' }}>
                                    <strong>
                                        <Icon type="close" /> {record.sub_category} (אין התאמה)
                                    </strong>
                                </div>
                            </div>
                        )}
                    </div>
                )
            },
            {
                title: 'מספר פוליסה מקור',
                key: 'policy_number',
                align: 'right',
                render: (_, record) => <div>{record.policy_number}</div>
            },
            {
                title: 'מחיר',
                key: 'policy_price',
                align: 'right',
                render: (_, record) => <div>{record.policy_price}</div>
            }
        ]
        return (
            <>
                <InsuranceSubPoliciesPopup />
                <InsuranceCaseCoversPopup />
                <div style={{ display: 'flex' }}>
                    <Input
                        style={{ margin: '0.2rem' }}
                        placeholder="שם פוליסה"
                        value={filters['policy_name']}
                        onChange={e => {
                            this.setCasesFilter({ policy_name: e.target.value, generic_policy_name: e.target.value })
                        }}
                    />
                    <Select
                        placeholder="סינון על פי חברה"
                        value={filters['company_id']}
                        style={{ width: '50%', margin: '0.2rem' }}
                        onChange={e => this.setCasesFilter({ company_id: e })}
                    >
                        {companiesStore.list
                            .filter(company => company.type === 'INSURANCE')
                            .map((company, index) => (
                                <Select.Option key={index} value={company.id}>
                                    {company.name}
                                </Select.Option>
                            ))}
                    </Select>
                    <Button onClick={() => this.handleResetFilters()}>איפוס חיפוש</Button>
                </div>
                <Table
                    className="center-table"
                    style={{ width: '100%' }}
                    rowKey="id"
                    loading={loading}
                    columns={columns}
                    rowClassName={record => (record.policy_id ? style.ok_row : style.fail_row)}
                    dataSource={showList}
                    pagination={{
                        total: showList.length,
                        pageSize: 20,
                        hideOnSinglePage: true
                    }}
                />
            </>
        )
    }
}

export default InsuranceCases
